<div>
  <a (click)="goToBack()" class="btn btn-default"> {{ 'people.back-to-list' | translate }}</a>
  <person-detail [person]="person"></person-detail>
</div>
